/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import AnalyticsService from 'cio/services/analytics';

interface ProductPlansToggleArgs {
  selectedPlan: string;
}
export default class ProductPlansToggle extends Component<ProductPlansToggleArgs> {
  @service analytics!: AnalyticsService;

  get productPlans() {
    return [
      {
        id: 'journeys',
        label: 'Journeys Plans',
        route: 'settings.billing.available-plans.journeys',
      },
      {
        id: 'data-pipelines',
        label: 'Data Pipelines Plans',
        route: 'settings.billing.available-plans.data-pipelines',
      },
    ];
  }

  @action
  trackToggle(plan: string) {
    this.analytics.track('plan_billing', 'available_plans_section_changed', {
      data: { next_section: plan },
    });
  }
}
